const statusTypes = {
  idle: 'idle',
  ready: 'ready',
};

export default statusTypes;
